import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import { LoginPage } from '../pages/auth/LoginPage';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { ClientOverviewPage } from '../pages/dashboard/ClientOverviewPage';
import { IntegrationHealthPage } from '../pages/dashboard/IntegrationHealthPage';
import { SystemStatusPage } from '../pages/dashboard/SystemStatusPage';
import { UserManagementPage } from '../pages/dashboard/UserManagementPage';

export const AppRouter: React.FC = () => {
	return (
		<Routes>
			<Route path="/login" element={<LoginPage />} />
			<Route path="/" element={<Navigate to="/dashboard/clients" replace />} />

			<Route
				path="/dashboard"
				element={
					<ProtectedRoute>
						<DashboardLayout />
					</ProtectedRoute>
				}>
				<Route path="clients" element={<ClientOverviewPage />} />
				<Route path="integration-health" element={<IntegrationHealthPage />} />
				<Route path="system-status" element={<SystemStatusPage />} />{' '}
				<Route path="user-management" element={<UserManagementPage />} />
				<Route index element={<Navigate to="clients" replace />} />
			</Route>
		</Routes>
	);
};
